import { useStore } from 'react-redux'
import { bindActionCreators } from 'redux'
import { useRef } from 'react'

import LandingZoneTagsApi from '@api/landingZones/tags'

import * as serviceHealthMapping from '@store/serviceHealth/action'

import { useApiError } from '@services/hooks/ApiError'

import { AZURE } from '@features/hooks/LandingZones'

export const useServiceHealth = () => {
    const store = useStore()
    const landingZoneServiceHealthAction = bindActionCreators(serviceHealthMapping, store.dispatch)

    const { handleError: apiError } = useApiError()

    const loaderCallback = useRef(null)

    const getHealth = () => {
        LandingZoneTagsApi.load(`/api/platform-health`, AZURE, 'kpi', '/user_impersonation', {'x-api-version': '2.0'}, {
            success: (result) => {
                landingZoneServiceHealthAction.populate(
                    result?.data,
                    () => { landingZoneServiceHealthAction.setLoaded(true, loaderCallback.current) }
                )
            },
            error: (result) => { apiError(result.data.message, 10000, false) }
        })
    }

    const load = (callback = null) => {
        loaderCallback.current = callback

        getHealth()
    }

    return { load }
}